import { Button, Loader, Token } from '@screentone/core';

import PageLock from 'components/page-lock/PageLock';
import { FragmentStateData } from 'contexts/page-lock/PageLockContext';
import styles from './PublicationSettingsActionBar.module.scss';

type PublicationSettingsActionBarProps = {
  onSave: () => void;
  hasChanged: boolean;
  isSaving: boolean;
  isLoading: boolean;
  publishingFragment: FragmentStateData;
  lockIsReady: boolean;
  isPageLockingEnabled: boolean;
  lockLoading: boolean;
  onLock: (withForce: boolean) => Promise<null>;
  onRelease: (withForce: boolean) => Promise<null>;
  lockType?: string;
};

function PublicationSettingsActionBar({
  onSave,
  hasChanged,
  isSaving,
  isLoading,
  publishingFragment,
  lockIsReady,
  isPageLockingEnabled,
  lockLoading,
  onLock,
  onRelease,
  lockType = 'Publication Settings'
}: PublicationSettingsActionBarProps) {
  return (
    <div className={styles.actionBar}>
      <div>{publishingFragment.isReadOnly && lockIsReady && <Token color="gray">Read Only</Token>}</div>
      <div className={styles.actionBarRight}>
        {lockIsReady && isPageLockingEnabled && (
          <PageLock
            publishingState={publishingFragment}
            release={onRelease}
            lock={onLock}
            loading={lockLoading}
            lockType={lockType}
          />
        )}
        {!lockIsReady && <Loader size="md" />}
        <Button
          primary
          onClick={onSave}
          disabled={isLoading || isSaving || !hasChanged || publishingFragment.isReadOnly}
        >
          Save
        </Button>
      </div>
    </div>
  );
}

export default PublicationSettingsActionBar;
